import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { TableModule } from 'primeng/table';
import { FormatPricePipe } from '../../pipes/format-price.pipe';
import { JobPlatform } from '../../interfaces/job-platform';

@Component({
  selector: 'app-platforms-pricing-list',
  templateUrl: './platforms-pricing-list.component.html',
  styleUrl: './platforms-pricing-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, FormatPricePipe, TableModule],
})
export class PlatformsPricingListComponent {
  selectedPlatforms = input<JobPlatform[]>();

  price = computed(() =>
    this.selectedPlatforms().reduce((acc, platform) => acc + platform.price, 0),
  );
}
